import React, {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';
import 'dayjs/locale/en'; // 영어로 로케일 설정
import timezone from 'dayjs/plugin/timezone'; // 타임존 플러그인 임포트
import advancedFormat from 'dayjs/plugin/advancedFormat'; // 서수(suffix) 사용을 위해 필요
import utc from 'dayjs/plugin/utc';
import {isEmpty} from "../../../../util";
import {FaUser} from "react-icons/fa6";
import {liveAPI} from "../../../../api/liveAPI";
import FileIcon from "../../../../assets/images/icon/FileIcon";
import FileRemoveIcon from "../../../../assets/images/icon/FileRemoveIcon";
import DoneIcon from "../../../../assets/images/icon/DoneIcon";
import FileInputIcon from "../../../../assets/images/icon/FileInputIcon";
import {cloneDeep} from "lodash";
import {commonAPI} from "../../../../api/commonAPI";
import axios from "axios";
import {classesAPI} from "../../../../api/classesAPI";
import scheduled from "../SubPage/Scheduled";
import {useNavigate} from "react-router-dom";
import {useRecoilState} from "recoil";
import {subMenuState} from "../../../../state"; // UTC 플러그인 추가
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat); // dayjs 확장
const CompletedPopup = (props) => {
  const [accept, setAccept] = useState(false);
  const [text, setText] = useState("")
  const timezoneSt = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const fileInputRef = useRef(null);
  const [selectedSubMenu ,setSelectedSubMenu] = useRecoilState(subMenuState);
  const [fileTitle, setFileTitle] = useState("");

  const setDate = () => {
    // const localDateTime = dayjs.utc(`${props?.data?.coachingApplication?.liveCoaching?.liveCoachingSlot?.localDate}T${props?.data?.coachingApplication?.liveCoaching?.liveCoachingSlot?.startTime}`).local();
    const localDateTime = dayjs(`${props?.data?.coachingApplication?.liveCoaching?.liveCoachingSlot?.localDate}T${props?.data?.coachingApplication?.liveCoaching?.liveCoachingSlot?.startTime}`).local();

    const estDateTime = localDateTime && localDateTime;
    // const estDateTime = localDateTime && localDateTime?.tz(timezoneSt);
    // const formattedDateTime = estDateTime.format('MMM Do h:mm A z');
    const formattedDateTime = estDateTime.format('MMM Do h:mm A');

    return formattedDateTime
  };

  const handleDownload = (fileUrl) => {
    // Create a link element
    const link = document.createElement('a');
    link.href = fileUrl;
    link.target = '_blank';
    link.download = "resume";

    // Simulate a click on the link to trigger the download
    link.click();
  };
  const navigate = useNavigate();
  const handleUploadJWP = async () => {
    const file = fileInputRef?.current?.files?.[0];

    if (!file) {
      return;
    }
    const formData = new FormData();
    const fileBlob = new Blob([file], {
      type: file?.type,
    });
    formData.append("file", fileBlob, file?.name);
    setFileTitle(file?.name);
    try {
      await liveAPI.putSendRecode(props?.data?.coachingApplication?.id,{
        data:formData
      })
          .then(res => {
            props?.onClickGetList();
            setSelectedSubMenu("Completed");
            navigate("/main/live");
            props?.onClickPopup();
          })
      // const result = await commonAPI.postVideoMetadata({
      //   data: {
      //     metadata: {
      //       title: file?.name,
      //     },
      //     upload: {
      //       mime_type: file?.type,
      //     },
      //     fileName: file?.name,
      //     preview: true,
      //   },
      // });
      // if (result) {
      //   console.log("result", result);
      //   const uploadLink = result.data.upload_link;
      //   const id = result?.data?.jwPlayerId;
      //   const name = file?.name;
      //
      // }
    } catch (error) {
      console.log("error", error);
    }
  };


  useEffect(() => {
    if(props?.data?.coachingApplication?.coachingStatus !== "REJECTED"){
      setAccept(true)
    }
  }, []);

  const onClickSubmit = async (accept, text) => {
    await liveAPI.putLiveReply(props?.data?.coachingApplication?.id, {
      params:{
        message:text,
        accept:accept
      }
    })
        .then(res => {
          props?.onClickGetList();
          props?.onClickPopup();
        })
  }

  useEffect(() => {
    setText(props?.data?.coachingApplication?.message || "")
  }, []);

  console.log("@props.data1",props.data);
  console.log("@accept",accept);

return(
  <Container
    onClick={()=>{
      props?.onClickPopup();
    }}
  >
    <Inner
      onClick={(e)=>{
        e.stopPropagation();
      }}
    >
      <Avatar>
        {
          !isEmpty(props?.data?.teacherThumbnailUrl) ?
              <img src={props?.data?.teacherThumbnailUrl} alt=""/>
              :
              <FaUser/>
        }
        <p>Live video call with</p>
        <span>{props?.data?.teacherName}</span>
      </Avatar>
      <Contents>
        <Details>
          <h2>Details</h2>
          <DetailsItem>
            <Icon>
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M0 8.32812C0 7.53248 0.316071 6.76941 0.87868 6.2068C1.44129 5.6442 2.20435 5.32813 3 5.32813H14.25C14.9776 5.32804 15.6805 5.59241 16.2277 6.07202C16.7749 6.55162 17.1292 7.21376 17.2245 7.93512L21.8895 5.86212C22.1178 5.76038 22.368 5.71732 22.6172 5.73685C22.8664 5.75639 23.1068 5.83789 23.3165 5.97397C23.5262 6.11004 23.6986 6.29637 23.8179 6.51601C23.9373 6.73565 23.9999 6.98164 24 7.23163V18.4246C23.9998 18.6744 23.9372 18.9202 23.8179 19.1397C23.6986 19.3591 23.5264 19.5453 23.3169 19.6813C23.1074 19.8174 22.8673 19.899 22.6183 19.9186C22.3693 19.9383 22.1193 19.8955 21.891 19.7941L17.2245 17.7211C17.1292 18.4425 16.7749 19.1046 16.2277 19.5842C15.6805 20.0638 14.9776 20.3282 14.25 20.3281H3C2.20435 20.3281 1.44129 20.0121 0.87868 19.4494C0.316071 18.8868 0 18.1238 0 17.3281V8.32812ZM17.25 16.0906L22.5 18.4246V7.23163L17.25 9.56562V16.0906ZM3 6.82812C2.60218 6.82812 2.22064 6.98616 1.93934 7.26747C1.65804 7.54877 1.5 7.9303 1.5 8.32812V17.3281C1.5 17.7259 1.65804 18.1075 1.93934 18.3888C2.22064 18.6701 2.60218 18.8281 3 18.8281H14.25C14.6478 18.8281 15.0294 18.6701 15.3107 18.3888C15.592 18.1075 15.75 17.7259 15.75 17.3281V8.32812C15.75 7.9303 15.592 7.54877 15.3107 7.26747C15.0294 6.98616 14.6478 6.82812 14.25 6.82812H3Z"
                      fill="#333333"/>
              </svg>
            </Icon>
            <TextArea>
              <TextTitle>
                {props?.data?.coachingApplication?.coachingStatus === "NEW" ? "Requested" : props?.data?.coachingApplication?.coachingStatus}
              </TextTitle>
            </TextArea>
          </DetailsItem>

          <DetailsItem>
            <Icon>
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.6429 3.39844C19.3817 3.39844 20.0902 3.69193 20.6127 4.21435C21.1351 4.73678 21.4286 5.44533 21.4286 6.18415V19.4699C21.4286 20.2087 21.1351 20.9172 20.6127 21.4397C20.0902 21.9621 19.3817 22.2556 18.6429 22.2556H5.35714C4.61832 22.2556 3.90977 21.9621 3.38734 21.4397C2.86492 20.9172 2.57143 20.2087 2.57143 19.4699V6.18415C2.57143 5.44533 2.86492 4.73678 3.38734 4.21435C3.90977 3.69193 4.61832 3.39844 5.35714 3.39844H18.6429ZM20.1429 8.97244H3.85714V19.4699C3.85714 20.2979 4.52914 20.9699 5.35714 20.9699H18.6429C19.0407 20.9699 19.4222 20.8118 19.7035 20.5305C19.9848 20.2492 20.1429 19.8677 20.1429 19.4699V8.97244ZM7.49914 15.8279C7.7833 15.8279 8.05582 15.9407 8.25675 16.1417C8.45769 16.3426 8.57057 16.6151 8.57057 16.8993C8.57057 17.1835 8.45769 17.456 8.25675 17.6569C8.05582 17.8578 7.7833 17.9707 7.49914 17.9707C7.21498 17.9707 6.94246 17.8578 6.74153 17.6569C6.54059 17.456 6.42771 17.1835 6.42771 16.8993C6.42771 16.6151 6.54059 16.3426 6.74153 16.1417C6.94246 15.9407 7.21498 15.8279 7.49914 15.8279ZM12.0026 15.8279C12.2867 15.8279 12.5593 15.9407 12.7602 16.1417C12.9611 16.3426 13.074 16.6151 13.074 16.8993C13.074 17.1835 12.9611 17.456 12.7602 17.6569C12.5593 17.8578 12.2867 17.9707 12.0026 17.9707C11.7184 17.9707 11.4459 17.8578 11.245 17.6569C11.044 17.456 10.9311 17.1835 10.9311 16.8993C10.9311 16.6151 11.044 16.3426 11.245 16.1417C11.4459 15.9407 11.7184 15.8279 12.0026 15.8279ZM7.49914 11.5422C7.7833 11.5422 8.05582 11.655 8.25675 11.856C8.45769 12.0569 8.57057 12.3294 8.57057 12.6136C8.57057 12.8977 8.45769 13.1703 8.25675 13.3712C8.05582 13.5721 7.7833 13.685 7.49914 13.685C7.21498 13.685 6.94246 13.5721 6.74153 13.3712C6.54059 13.1703 6.42771 12.8977 6.42771 12.6136C6.42771 12.3294 6.54059 12.0569 6.74153 11.856C6.94246 11.655 7.21498 11.5422 7.49914 11.5422ZM12.0026 11.5422C12.2867 11.5422 12.5593 11.655 12.7602 11.856C12.9611 12.0569 13.074 12.3294 13.074 12.6136C13.074 12.8977 12.9611 13.1703 12.7602 13.3712C12.5593 13.5721 12.2867 13.685 12.0026 13.685C11.7184 13.685 11.4459 13.5721 11.245 13.3712C11.044 13.1703 10.9311 12.8977 10.9311 12.6136C10.9311 12.3294 11.044 12.0569 11.245 11.856C11.4459 11.655 11.7184 11.5422 12.0026 11.5422ZM16.5069 11.5422C16.791 11.5422 17.0635 11.655 17.2645 11.856C17.4654 12.0569 17.5783 12.3294 17.5783 12.6136C17.5783 12.8977 17.4654 13.1703 17.2645 13.3712C17.0635 13.5721 16.791 13.685 16.5069 13.685C16.2227 13.685 15.9502 13.5721 15.7492 13.3712C15.5483 13.1703 15.4354 12.8977 15.4354 12.6136C15.4354 12.3294 15.5483 12.0569 15.7492 11.856C15.9502 11.655 16.2227 11.5422 16.5069 11.5422ZM18.6429 4.68415H5.35714C4.95932 4.68415 4.57779 4.84219 4.29648 5.12349C4.01518 5.4048 3.85714 5.78633 3.85714 6.18415V7.68672H20.1429V6.18415C20.1429 5.78633 19.9848 5.4048 19.7035 5.12349C19.4222 4.84219 19.0407 4.68415 18.6429 4.68415Z"
                    fill="#333333"/>
              </svg>

            </Icon>
            <TextArea>
              <TextTitle>
                Proposed dates:
              </TextTitle>
              <TextContents>
                <div className="date">
                  <p>{setDate()}</p>
                </div>
              </TextContents>
            </TextArea>
          </DetailsItem>
          <DetailsItem>
            <Icon>
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 23.3281C9.9233 23.3281 7.89323 22.7123 6.16652 21.5586C4.4398 20.4048 3.09399 18.7649 2.29927 16.8463C1.50455 14.9277 1.29661 12.8165 1.70176 10.7797C2.1069 8.74288 3.10693 6.87196 4.57538 5.40351C6.04383 3.93506 7.91476 2.93503 9.95156 2.52988C11.9884 2.12474 14.0996 2.33267 16.0182 3.12739C17.9368 3.92211 19.5767 5.26793 20.7304 6.99464C21.8842 8.72136 22.5 10.7514 22.5 12.8281C22.5 15.6129 21.3938 18.2836 19.4246 20.2528C17.4555 22.2219 14.7848 23.3281 12 23.3281ZM12 3.82813C10.22 3.82813 8.47992 4.35597 6.99987 5.3449C5.51983 6.33384 4.36628 7.73944 3.68509 9.38398C3.0039 11.0285 2.82567 12.8381 3.17294 14.5839C3.5202 16.3298 4.37737 17.9334 5.63604 19.1921C6.89472 20.4508 8.49836 21.3079 10.2442 21.6552C11.99 22.0025 13.7996 21.8242 15.4442 21.143C17.0887 20.4619 18.4943 19.3083 19.4832 17.8283C20.4722 16.3482 21 14.6082 21 12.8281C21 10.4412 20.0518 8.152 18.364 6.46417C16.6761 4.77634 14.387 3.82813 12 3.82813Z"
                    fill="#333333"/>
                <path d="M15.4425 17.3281L11.25 13.1356V6.07812H12.75V12.5131L16.5 16.2706L15.4425 17.3281Z"
                      fill="#333333"/>
              </svg>
            </Icon>
            <TextArea>
              <TextTitle>
                {props?.data?.coachingApplication?.liveCoaching?.duration} min
              </TextTitle>

            </TextArea>
          </DetailsItem>

          <DetailsItem style={{borderBottom:"none"}}>
            <Icon>
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 21.8281C13.78 21.8281 15.5201 21.3003 17.0001 20.3114C18.4802 19.3224 19.6337 17.9168 20.3149 16.2723C20.9961 14.6277 21.1743 12.8181 20.8271 11.0723C20.4798 9.32649 19.6226 7.72284 18.364 6.46417C17.1053 5.2055 15.5016 4.34833 13.7558 4.00106C12.01 3.65379 10.2004 3.83202 8.55585 4.51321C6.91131 5.1944 5.50571 6.34795 4.51677 7.828C3.52784 9.30804 3 11.0481 3 12.8281C3 14.3161 3.36 15.7191 4 16.9551L3 21.8281L7.873 20.8281C9.109 21.4681 10.513 21.8281 12 21.8281Z"
                    stroke="#333333" strokeWidth={"1.5"} strokeLinecap={"round"} strokeLinejoin={"round"}/>
              </svg>
            </Icon>
            <TextArea>
              <TextTitle style={{fontSize: 20}}>
                Text title
              </TextTitle>
              <TextContents>
                <div className="desc">
                  <p>
                    {props?.data?.coachingApplication?.liveCoaching?.whatDoYouWantToTalk}
                  </p>
                </div>
              </TextContents>
            </TextArea>
          </DetailsItem>
        </Details>
        <Details>
          <h2>Your answer</h2>
          <p className={"ready"}>
            Get ready for your video call with the steps below: </p>
          <Radio>
            <RadioButton
                onClick={() => {
                  // updateReqData("accept", true)
                  if(props?.scheduled) return;
                  setAccept(true)
                }}
                className={accept ? "on" : ""}
            >
              <div className="circle"></div>
              <span>
                                Accept
                            </span>
            </RadioButton>
            <RadioButton
                onClick={() => {
                  // updateReqData("accept", false)
                  if(props?.scheduled) return;
                  setAccept(false)
                }}
                className={accept !== true ? "on" : ""}>
              <div className="circle"></div>
              <span>
                                Decline
                            </span>
            </RadioButton>
          </Radio>
          {/*<ActionBtn>*/}
          {/*  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
          {/*    <path fill-rule="evenodd" clip-rule="evenodd"*/}
          {/*          d="M0 7.82812C0 7.03248 0.316071 6.26941 0.87868 5.7068C1.44129 5.1442 2.20435 4.82813 3 4.82813H14.25C14.9776 4.82804 15.6805 5.09241 16.2277 5.57202C16.7749 6.05162 17.1292 6.71376 17.2245 7.43512L21.8895 5.36212C22.1178 5.26038 22.368 5.21732 22.6172 5.23685C22.8664 5.25639 23.1068 5.33789 23.3165 5.47397C23.5262 5.61004 23.6986 5.79637 23.8179 6.01601C23.9373 6.23565 23.9999 6.48164 24 6.73163V17.9246C23.9998 18.1744 23.9372 18.4202 23.8179 18.6397C23.6986 18.8591 23.5264 19.0453 23.3169 19.1813C23.1074 19.3174 22.8673 19.399 22.6183 19.4186C22.3693 19.4383 22.1193 19.3955 21.891 19.2941L17.2245 17.2211C17.1292 17.9425 16.7749 18.6046 16.2277 19.0842C15.6805 19.5638 14.9776 19.8282 14.25 19.8281H3C2.20435 19.8281 1.44129 19.5121 0.87868 18.9494C0.316071 18.3868 0 17.6238 0 16.8281V7.82812ZM17.25 15.5906L22.5 17.9246V6.73163L17.25 9.06562V15.5906ZM3 6.32812C2.60218 6.32812 2.22064 6.48616 1.93934 6.76747C1.65804 7.04877 1.5 7.4303 1.5 7.82812V16.8281C1.5 17.2259 1.65804 17.6075 1.93934 17.8888C2.22064 18.1701 2.60218 18.3281 3 18.3281H14.25C14.6478 18.3281 15.0294 18.1701 15.3107 17.8888C15.592 17.6075 15.75 17.2259 15.75 16.8281V7.82812C15.75 7.4303 15.592 7.04877 15.3107 6.76747C15.0294 6.48616 14.6478 6.32812 14.25 6.32812H3Z"*/}
          {/*          fill="#333333"/>*/}
          {/*  </svg>*/}
          {/*  <p style={{marginLeft:10}}>Check audio, video, WIFI</p>*/}
          {/*</ActionBtn>*/}
          <textarea
            onChange={(e)=>{
              if(props?.scheduled) return;
              const value = e.target.value;
              setText(value)
            }}
            value={text}
          />
        </Details>
      </Contents>
      {
        props?.data?.coachingApplication.coachingStatus == "REJECTED" ?
            ""
            :
          !props?.scheduled ?
          <Btns
              onClick={async ()=>{
                await onClickSubmit(accept, text)
              }}
          >
            <span>Send</span>
          </Btns>
            :
            <Btns>
              {/*coachingApplication.liveRecord.url*/}
              <Upload>
                <InputArea>
                  <h4>Please add attachment here</h4>
                  <InputContents
                    style={{
                      cursor:"pointer"
                    }}
                    onClick={()=>{
                      if(props?.data?.coachingApplication.coachingStatus !== "COMPLETED") return;
                      handleDownload(props?.data?.coachingApplication?.liveRecord?.url)
                    }}
                  >
                    {
                        props?.data?.coachingApplication.coachingStatus !== "COMPLETED" &&
                    <input

                        ref={fileInputRef}
                        type="file"
                        onChange={async ()=>{
                          await handleUploadJWP()
                        }}
                    />
                    }
                    <InputIcons>
                      <FileInputIcon />
                      {/*<p>Add file or drop file here</p>*/}
                      <p>
                      {
                        props?.data?.coachingApplication.coachingStatus == "COMPLETED" ?
                            `${props?.data?.coachingApplication.liveRecord.fileName}` : "Add file or drop file here"
                      }
                      </p>
                    </InputIcons>
                  </InputContents>
                </InputArea>
              </Upload>
            </Btns>
      }
    </Inner>
  </Container>
)
};
export default CompletedPopup;

const Container = styled.div`
  color: rgba(51, 51, 51, 1);
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Avatar = styled.div`
  color: rgba(51, 51, 51, 1);

  p {
    margin-top: 15px;
    font-family: Europa-Regular;
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0px;
    text-align: left;
    margin-bottom: 10px;
  }

  img, svg {
    width: 100px;
    height: 100px;
    border-radius: 50%;
  }

  svg {
    color: #ddd;
    background: rgba(227, 227, 227, 0.32);
  }

  span {
    font-family: Europa-Bold;
    font-size: 26px;
    font-weight: 700;
    line-height: 26px;
    letter-spacing: 0em;
    text-align: left;

  }
`
const Details = styled.div`
  h2 {
    font-family: Europa-Bold;
    font-size: 22px;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: left;
  }
  textarea{
    border: 1px solid rgba(51, 51, 51, 0.3);
    border-radius: 15px;
    resize: none;
    width: 100%;
    display: flex;
    flex: 1;
    height: calc(100% - 125px);
    margin-top: 15px;
    padding: 15px;
    outline: none;
    font-family: Europa-Bold;
    font-size: 16px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: -0.3199999928474426px;
    text-align: left;
  }  
  .ready {
    margin-top: 15px;
    font-family: Europa-Regular;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0px;
    text-align: left;
    overflow-y: scroll;
  }
`
const Actions = styled.div`

`
const Contents = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: space-between;

  & > div {
    width: 45%;
  }
`
const Btns = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 15px;
  border-top: 1px solid rgba(51, 51, 51, 0.3);
  padding-top: 20px;
  span {
     cursor: pointer;
     font-family: Arial;
     font-size: 15px;
     font-weight: 700;
     line-height: 17px;
     letter-spacing: 0em;
     text-align: center;
     padding: 12px 89px;
     border-radius: 30px;
    color: #fff;
     background: rgba(221, 193, 96, 1);
   }
`
const Upload = styled.div`
   width: 100%;
`
const InputArea = styled.div`
    margin-bottom: 27px;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  width: 100%;
    h4 {
      width: 80%;
      text-align: left;
        font-size: 14px;
        line-height: 21px;
        font-weight: 400;
        margin-bottom: 5px;
    }
`;
const InputContents = styled.div`
    position: relative;
    height: 52px;
    width: 80%;
    border: 1px solid #ddd;
    color: #e0c463;
    border-radius: 10px;
    input {
        cursor: pointer;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        position: absolute;
        z-index: 9;
        opacity: 0;
    }
`;
const RemoveButton = styled.div`
    height: 100%;
    z-index: 10;
    display: flex;
    align-items: center;
    padding: 10px 18px;
    cursor: pointer;
`;
const InputIcons = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    justify-content: center;

    margin-bottom: 11px;
    padding: 0 20px;
    border-radius: 10px;
    &.on {
        background-color: #eff3fe;
        border: 2px solid #276ef1;
    }
    & > div {
        display: flex;
        align-items: center;
        .remove_svg_icon {
        }
        svg {
            &:nth-child(1) {
            }
        }
    }
    p {
        margin-left: 18px;
        font-size: 16px;
        font-weight: 700;
        color: #e0c463;
    }
    span {
        font-weight: 400;
        font-size: 17px;
        line-height: 21px;
        color: #111;
    }
`;
const ActionBtn = styled.div`
   display: flex;
  align-items: center;
  justify-content: center;
  height: 41px;
  border-radius: 30px;
  cursor: pointer;
  margin-top: 20px;
  border: 1px solid rgba(51, 51, 51, 1)
`
const DetailsItem = styled.div`
  display: flex;
  align-items: flex-start;
  border-bottom: rgba(51, 51, 51, 0.3) solid 1px;
  padding: 15px 0;
`
const Icon = styled.div`
  height: 20px;
  display: flex;
  align-items: center;
`
const TextArea = styled.div`

`
const TextTitle = styled.div`
  font-family: Europa-Bold;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0px;
  text-align: left;
  vertical-align: center;
  color: #333;  
  line-height: 24px;
  display: flex;
  align-items: center;
  margin-left:10px;
`
const TextContents = styled.div`
  margin-top:10px;
  margin-left:10px;
  color: rgba(51, 51, 51, 1);
  .date{
    font-family: Europa-Bold;
    font-size: 16px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: -0.3199999928474426px;
    text-align: left;
  }
  .time{
    
  }
  .desc{
    font-family: Europa-Regular;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0px;
    text-align: left;
    max-height: 100px;
    min-height: 80px;
    overflow-y: scroll;
  }
   
`
const Inner = styled.div`
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(221, 193, 96, 0.5);
  border-radius: 15px;
  max-height: 90vh;
  overflow-y: auto;
  width: 50vw;
  padding: 30px;
`
const Radio = styled.div`
   display: flex;
    align-items: center;
`
const RadioButton = styled.div`
    display: flex;
    align-items: center;
    transition: all 0.3s;
    margin-right: 57px;
    cursor: pointer;
   .circle{
       transition: all 0.3s;
       width: 20px;
       height: 20px;
       border-radius: 100px;
       border:solid 1px #33333326;
       .on&{
           border:solid 5px #DDC160;
       }
   }
   span{
       margin-left: 10px;
       font-family: Europa-Bold;
       font-size: 20px;
       font-weight: 700;
       line-height: 30px;
       letter-spacing: 0em;
       text-align: left;
   }
`